export default __webpack_public_path__ + "static/media/pacco_regaloTtsIt_It60.4aa23359.mp3";